if (!customElements.get('nb-addons')) {
  class NBAddons extends HTMLElement {
    constructor() {
      super();
      this.container = this.querySelector('[js-addon]');
      this.button = this.querySelector('[js-addon-button]');
      this.dropdown = this.querySelector('[js-addon-dropdown]');
      this.options = this.querySelectorAll('[js-addon-option]');

      this.init();
    }

    init() {
      // Handle button click
      this.button.addEventListener('click', () => {
        const isOpen = this.button.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          this.closeDropdown();
        } else {
          this.openDropdown();
        }
      });

      // Handle keyboard events on options
      this.options.forEach((option) => {
        option.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' || event.key === 'Enter') {
            const isOpen = this.button.getAttribute('aria-expanded') === 'true';
            if (isOpen) {
              event.preventDefault();
              this.closeDropdown();
            }
          }
        });
      });
    }

    openDropdown() {
      this.button.setAttribute('aria-expanded', 'true');
      this.dropdown.removeAttribute('hidden');
    }

    closeDropdown() {
      this.button.setAttribute('aria-expanded', 'false');
      this.dropdown.setAttribute('hidden', '');
      this.button.focus();
    }
  }

  customElements.define('nb-addons', NBAddons);
}
